import React, { useEffect, useState } from "react";
import { getCachedPdfDocument } from "./pdfCache"; // 여기로 임포트

export default function PDFSingleThumbnail({
                                               pdfUrl,
                                               pageNumber = 1,
                                               scale = 0.3,
                                               className = "",
                                           }) {
    const [thumbnailSrc, setThumbnailSrc] = useState(null);

    useEffect(() => {
        let isMounted = true;

        async function renderPage() {
            try {
                // ★ 캐시 활용
                const pdf = await getCachedPdfDocument(pdfUrl);
                // 만약 pageNumber가 범위 밖이면 1페이지로
                const validPageNumber = Math.max(1, Math.min(pageNumber, pdf.numPages));
                const page = await pdf.getPage(validPageNumber);

                const viewport = page.getViewport({ scale });
                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");
                canvas.width = viewport.width;
                canvas.height = viewport.height;

                const renderContext = { canvasContext: context, viewport };
                await page.render(renderContext).promise;

                const dataUrl = canvas.toDataURL("image/png");
                if (isMounted) setThumbnailSrc(dataUrl);
            } catch (error) {
                console.error("PDF 페이지 썸네일 생성 오류:", error);
            }
        }

        renderPage();
        return () => {
            isMounted = false;
        };
    }, [pdfUrl, pageNumber, scale]);

    if (!thumbnailSrc) {
        return (
            <div
                className={className}
                style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >
                로딩중...
            </div>
        );
    }

    return (
        <img
            src={thumbnailSrc}
            alt={`pdf-page-${pageNumber}`}
            className={className}
        />
    );
}